import SelectOption from '@/store/dict/selectOptionDict'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  data() {
    return {
      taskTableColumns: [
        {
          name: 'uploadDate',
          columnProps: {
            label: '上传时间',
            prop: 'uploadDate',

          },
        },
        {
          name: 'createUser',
          columnProps: {
            label: '操作人姓名',
            prop: 'createUser',
          },
        },
        {
          name: 'userAccount',
          columnProps: {
            label: '操作人账号',
            prop: 'userAccount',
          },
        },
        {
          name: 'type',
          columnProps: {
            label: '导入类型',
          },
          getText: ({ row }) => SelectOption.taskType[row.type],
        },
        {
          name: 'fileName',
          columnProps: {
            label: '导入文件',
          },
          render: ({ row }) => {
            if (!row.fileUrl) return '--'
            const docType = row.fileUrl.split('.').pop()
            if (!docType) return '--'
            const fileName = row.fileName || `${SelectOption.taskType[row.type]}${row.uploadDate}.${docType}`
            return this.$createElement('a', {
              attrs: {
                href: row.fileUrl,
                download: fileName,
              },
              style: {
                color: '#2e7eff',
              },
            }, [fileName])
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '导入状态',
          },
          getText: ({ row }) => SelectOption.importStatus[row.state],
        },
        {
          name: 'ocrState',
          columnProps: {
            label: 'OCR状态',
          },
          getText: ({ row }) => SelectOption.ocrStatus[row.ocrState],
        },
        {
          name: 'deptName',
          columnProps: {
            label: '所属部门',
            prop: 'deptName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '错误说明',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          render: ({ row }) => {
            // 导入状态
            // 3:全部成功
            const successImportStatus = [3]
            // 4:全部错误 5:部分错误
            const errorImportStatus = [4, 5]
            const hasErrorDetail = errorImportStatus.includes(row.state) && row.resultInfo === '错误详情'
            const hasOcrErrorDetail = errorImportStatus.includes(row.ocrState)
            const isAllSuccess = successImportStatus.includes(row.state)

            const highlightBtnColor = ''
            const commonBtnColor = '#606266'

            const btns = []

            if (hasErrorDetail) {
              btns.push(
                this.$createElement('el-button', {
                  class: {
                    'error-detail-btn': true,
                  },
                  props: {
                    type: 'text',
                    size: 'small',
                  },
                  style: {
                    color: highlightBtnColor,
                  },
                  on: {
                    click: () => {
                      this.viewErrorDetail(row.id)
                    },
                  },
                }, row.resultInfo),
              )

              btns.push(
                this.$createElement('el-button', {
                  class: {
                    'error-download-btn': true,
                  },
                  props: {
                    type: 'text',
                    size: 'small',
                  },
                  style: {
                    color: highlightBtnColor,
                  },
                  on: {
                    click: () => {
                      this.downloadErrorDetail(row.id)
                    },
                  },
                }, '下载错误明细'),
              )
            } else {
              btns.push(
                this.$createElement('el-button', {
                  props: {
                    type: 'text',
                    size: 'small',
                  },
                  style: {
                    color: commonBtnColor,
                  },
                }, isAllSuccess ? '--' : row.resultInfo),
              )
            }

            if (hasOcrErrorDetail) {
              btns.push(
                this.$createElement('el-button', {
                  class: {
                    'ocr-detail-btn': true,
                  },
                  props: {
                    type: 'text',
                    size: 'small',
                  },
                  style: {
                    color: highlightBtnColor,
                  },
                  on: {
                    click: () => {
                      this.viewOcrErrorDetail(row.id)
                    },
                  },
                }, 'OCR日志'),
              )
            }

            return this.$createElement('div', {
              // style: {
              //   textAlign: 'center'
              // }
            }, btns)
          },
        },
      ],
      errorTableColums: [
        {
          name: 'lineId',
          columnProps: {
            label: '文件名',
            prop: 'lineId',

          },
        },
        {
          name: 'resultInfo',
          columnProps: {
            label: '错误类型',
            prop: 'resultInfo',

          },
        },
      ],
      ocrErrorTableColums: [
        {
          name: 'fileName',
          columnProps: {
            label: '文件名',
            prop: 'fileName',
          },
        },
        {
          name: 'filePath',
          columnProps: {
            label: '图片预览',
            prop: 'filePath',
          },
        },
        {
          name: 'failReason',
          columnProps: {
            label: '错误原因',
            prop: 'failReason',
          },
        },
      ],
    }
  },
}
